import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Sheet } from '@paypalcorp/pp-react-sheet';
import { HeadingText } from '@paypalcorp/pp-react-text';
import DropzoneLogo from './DropzoneLogo';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';

const ImageModal = ({
  getContent,
  isOpen,
  handleCloseModal,
  dispatch,
  uploadImage,
  updateBusinessProfileLogo,
  updateBusinessImageUrls,
  logoUrl,
  isLogoBusinessProfile,
  setLogoImg,
  logoTarget,
  setIsLogoBusinessProfile,
}) => {
  const title = getContent('modal.title');

  useEffect(() => {
    if (isOpen) {
      trackEventWithData(FPTI_SPEC.UPLOAD_LOGO_MODAL_IM);
    }
  }, [isOpen]);

  const handleDismissClick = () => {
    trackEventWithData(FPTI_SPEC.UPLOAD_LOGO_MODAL_DISMISS_CL);
    handleCloseModal();
  };

  return (
    <Sheet
      id="image-logo-modal"
      className="image-logo-modal"
      isOpen={isOpen}
      onClose={handleDismissClick}
      hideTitle={true}
    >
      <HeadingText className="modal-title" size="lg">
        {title}
      </HeadingText>

      <DropzoneLogo
        dispatch={dispatch}
        getContent={getContent}
        uploadImage={uploadImage}
        updateBusinessProfileLogo={updateBusinessProfileLogo}
        updateBusinessImageUrls={updateBusinessImageUrls}
        closeModal={handleCloseModal}
        logoUrl={logoUrl}
        setLogoImg={setLogoImg}
        logoTarget={logoTarget}
        isLogoBusinessProfile={isLogoBusinessProfile}
        setIsLogoBusinessProfile={setIsLogoBusinessProfile}
      />
    </Sheet>
  );
};

ImageModal.propTypes = {
  getContent: PropTypes.func,
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  dispatch: PropTypes.func,
  uploadImage: PropTypes.func,
  updateBusinessProfileLogo: PropTypes.func,
  updateBusinessImageUrls: PropTypes.func,
  logoUrl: PropTypes.string,
  setLogoImg: PropTypes.func,
  logoTarget: PropTypes.string,
  isLogoBusinessProfile: PropTypes.bool,
  setIsLogoBusinessProfile: PropTypes.func,
};

export default ImageModal;
